



















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class ConfirmModal extends Vue {
  private eventEmit = {
    eventCloseModal: 'eventCloseModal',
    eventAcceptModal: 'eventAcceptModal',
    eventOtherModal: 'eventOtherModal'
  };

  @Prop({default: false})
  private isShowModal!: boolean;

  @Prop({default: ''})
  private content!: string;

  @Prop({default: true})
  public showNextButton!: boolean;
  
  @Prop({default: true})
  public showCloseButton!: boolean;
  
  @Prop({default: false})
  public showOtherButton!: boolean;

  @Prop({default: 'Tiếp tục'})
  public nextButtonText!: string;

  @Prop({default: 'Nạp tiền'})
  public otherButtonText!: string;

  @Prop({default: false})
  public isPayOrder!: boolean;
  private shipAddress!: string;
  private shipPhone!: string;
  private shipNote!: string;
  private shipType = 1;


  private async created() {
    document.documentElement.style.overflow = 'hidden';
  }

  private onClose() {
      document.documentElement.style.overflow = 'auto';
      this.$emit(this.eventEmit.eventCloseModal, {
        data: null,
        close: true
      });
  }

  private onAccept() {
    document.documentElement.style.overflow = 'auto';
    this.$emit(this.eventEmit.eventAcceptModal, {
        data: 'OK',
        shipType: this.shipType,
        shipAddress: this.shipAddress,
        shipPhone: this.shipPhone,
        shipNote: this.shipNote,
        close: true
    });
  }
  
  private onOtherAction() {
    document.documentElement.style.overflow = 'auto';
    this.$emit(this.eventEmit.eventOtherModal, {
        data: 'OK',
        shipType: this.shipType,
        shipAddress: this.shipAddress,
        shipPhone: this.shipPhone,
        shipNote: this.shipNote,
        close: true
    });
  }
}
